import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../../styles/styles';
import Popup from '../Popup';
import RegistrationForm from '../Form/RegistrationForm';
import Logo from '../Logo';
import registerBg from '../../assets/registration_image.png';

const RegistrationPopup = ({ classes, handleLoginPopup }) => (
  <div>
     <RegistrationForm />
  </div>
  // <MDBContainer fluid>
  //     <MDBRow>
  //       <MDBCol md="3"></MDBCol>
  //       <MDBCol md="6">
  //         <div className="d-none d-sm-block" style={{height:80}}></div>
  //         <MDBCard>
  //           <div className="header pt-3">
  //             <MDBRow className="">
  //               <h3 className="gotham-bold w-100 lg-text center mt-2 mb-2 pb-1 mx-5">
  //                 Forgotten Password
  //               </h3>
  //             </MDBRow>
  //           </div>
  //           <div className="secondary-color pt-4 pb-4 pl-1 pr-1 w-70">
  //                <img className="longLogo" src={logoLong} />
  //           </div>
  //           <MDBCardBody className="mt-4">
  //             <form onSubmit={handleSubmit(handleSubmitForgottenPassword)} className={classes.form}>
               
  //               <MDBRow center className="w-100">
  //                 <MDBCol lg="10" className="w-100">
  //                   <Field name="Email" label="Email" component={EmailField} />
  //                 </MDBCol>
  //               </MDBRow>
  //            <MDBRow center className="w-100 pt-4">
  //               <MDBCol lg="4" className="left">
  //                   <MDBBtn
  //                     color="success"
  //                     right
  //                     size="md"
  //                     className='ml-auto ml-4 mt-0 w-100 mb-2'
  //                     action
  //                     type="submit"
  //                     disabled={submitting}>
  //                     Request
  //                   </MDBBtn>
  //               </MDBCol>
               
  //             </MDBRow>
  //           </form>
              
              
  //             <div className="md-text grey-text d-flex justify-content-center pt-2">
              
  //               <div
  //                 className="dark-grey-text gotham-bold ml-1"
  //                 onClick={event => handleLoginPopup(event)}
  //               >
  //                 Back to Login
  //               </div>
  //             </div>
             
  //           </MDBCardBody>
  //         </MDBCard>
  //       </MDBCol>
  //       <MDBCol md="3"></MDBCol>
  //     </MDBRow>
  //   </MDBContainer>
  // <Popup>
  //   <div className={classes.popupWrapper}>
  //     <div className={classes.popupContainer}>
  //       <div className={classes.leftSide} style={{ backgroundImage: `url(${registerBg})` }}>
  //         <Logo className={classes.logoPopup} wideLogo />
  //       </div>
  //       <div className={classes.rightSide}>
  //       <div className={classes.topPart2} style={{ position: 'absolute', top:0, paddingTop:20, paddingBottom:20 }}>            <Typography variant="headline" gutterBottom className={classes.popupSubtitle}>
  //             Sign Up
  //           </Typography>
            
  //           <RegistrationForm />
  //           <Typography variant="caption" className={classes.registrationCaption} style={{ textAlign: 'center',}}>
  //           {'Already have an account? '}
  //           <Typography
  //             className={classes.registrationLink}
  //             onClick={event => handleLoginPopup(event)}
  //           >
  //             Log in
  //           </Typography>
  //         </Typography>
  //         </div>
          
  //       </div>
  //     </div>
  //   </div>
  // </Popup>
);

RegistrationPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleLoginPopup: PropTypes.func,
};
const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(RegistrationPopup);



// WEBPACK FOOTER //
// ./src/Components/Popups/RegistrationPopup.jsx